/**
 * Module dependencies.
 */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftRight, CandlestickChart, FileBarChart, PieChart } from 'lucide-react';
import { Outlet } from 'react-router-dom';
import { appRoutes } from 'app/routes';
import { compileMenu } from 'app/core/utils/menu';
import { Dashboard } from './dashboard';

/**
 * Export `SkinAppsCrypto` component.
 */

export function SkinAppsCrypto(): JSX.Element {
  const [translate] = useTranslation();
  const items = useMemo(
    () =>
      compileMenu([
        {
          key: '1',
          pathname: appRoutes.dashboard.appsCrypto.base,
          icon: <PieChart className={'h-4 w-4'} />,
          label: translate('appsCrypto.menu.overview')
        },
        {
          key: '2',
          pathname: appRoutes.dashboard.appsCrypto.transactions,
          icon: <ArrowLeftRight className={'h-4 w-4'} />,
          label: translate('appsCrypto.menu.transactions')
        },
        {
          key: '3',
          pathname: appRoutes.dashboard.appsCrypto.trades,
          icon: <CandlestickChart className={'h-4 w-4'} />,
          label: translate('appsCrypto.menu.trades')
        },
        {
          key: '4',
          pathname: appRoutes.dashboard.appsCrypto.providers,
          icon: <FileBarChart />,
          label: translate('appsCrypto.menu.providers')
        }
      ]),
    [translate]
  );

  return (
    <Dashboard menu={items}>
      <Outlet />
    </Dashboard>
  );
}
